import { VersionConfig, EditionType } from '@/types/assessment';
import { highSchoolConfig } from '@/data/highschool';
import { collegeConfig } from '@/data/college';
import { professionalConfig } from '@/data/professional';

export type PortalType = 'hs' | 'college' | 'pro';

export interface PortalConfig {
  portal: PortalType;
  edition: EditionType;
  config: VersionConfig;
  basePath: string;
  label: string;
}

const portalMap: Record<PortalType, PortalConfig> = {
  hs: {
    portal: 'hs',
    edition: 'highschool',
    config: highSchoolConfig,
    basePath: '/hs',
    label: 'High School',
  },
  college: {
    portal: 'college',
    edition: 'college',
    config: collegeConfig,
    basePath: '/college',
    label: 'College',
  },
  pro: {
    portal: 'pro',
    edition: 'professional',
    config: professionalConfig,
    basePath: '/pro',
    label: 'Professional',
  },
};

export function getPortalConfig(portal: PortalType): PortalConfig {
  return portalMap[portal];
}

export function getPortalFromPath(pathname: string): PortalType | null {
  if (pathname.startsWith('/hs')) return 'hs';
  if (pathname.startsWith('/college')) return 'college';
  if (pathname.startsWith('/pro')) return 'pro';
  return null;
}
